import { render, staticRenderFns } from "./LpuCardsSortBottomSheet.vue?vue&type=template&id=684e517a&scoped=true&"
import script from "./LpuCardsSortBottomSheet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsSortBottomSheet.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsSortBottomSheet.vue?vue&type=style&index=0&id=684e517a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e517a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684e517a')) {
      api.createRecord('684e517a', component.options)
    } else {
      api.reload('684e517a', component.options)
    }
    module.hot.accept("./LpuCardsSortBottomSheet.vue?vue&type=template&id=684e517a&scoped=true&", function () {
      api.rerender('684e517a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsSortBottomSheet.vue"
export default component.exports